import styled from 'styled-components';
import { Flex } from '#atoms';

type HistoryTitleProps = {
  title: string;
  onIconClick?: () => void;
};

export default function HistoryTitle({
  title,
  onIconClick
}: HistoryTitleProps) {
  return (
    <Wrapper justify="space-between" align="center">
      <Label>{title}</Label>
      <IconWrapper onClick={onIconClick}>
        <PlusIcon />
      </IconWrapper>
    </Wrapper>
  );
}

const Wrapper = styled(Flex)`
  padding-bottom: 12px;
  border-bottom: 1px solid ${({ theme }) => theme.palette.gray600};
`;

const Label = styled.span`
  color: ${({ theme }) => theme.palette.gray15};
  font-size: 18px;
  font-weight: 700;
`;

const IconWrapper = styled.span`
  height: 24px;
`;

const PlusIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path d="M11 13H3V11H11V3H13V11H21V13H13V21H11V13Z" fill="#9170F2" />
  </svg>
);
